const ExclamationIcon = ({ width = 16, height = 16, color = '#DA291C' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9974 8.0013C13.9974 11.315 11.3111 14.0013 7.99739 14.0013C4.68368 14.0013 1.9974 11.315 1.9974 8.0013C1.9974 4.68759 4.68368 2.0013 7.99739 2.0013C11.3111 2.0013 13.9974 4.68759 13.9974 8.0013ZM7.99739 15.3346C12.0475 15.3346 15.3307 12.0514 15.3307 8.0013C15.3307 3.95121 12.0475 0.667969 7.99739 0.667969C3.94731 0.667969 0.664063 3.95121 0.664063 8.0013C0.664063 12.0514 3.94731 15.3346 7.99739 15.3346ZM7.33144 4.68001L7.33144 8.65706L7.9981 9.30078L8.66477 8.65706L8.66477 4.68001H7.33144ZM8.66288 11.3354V10.6917L7.99621 10.0479L7.32954 10.6917V11.3354L8.66288 11.3354Z"
        fill={color}
      />
    </svg>
  )
}

export default ExclamationIcon
